module.exports = __webpack_public_path__ + "img/I.dc07f1ea.png";